import { useEffect, useRef } from 'react';

/**
 * Custom hook for running a callback function on mount.
 *
 * to avoid the need to track the mounted state of a component manually,
 * which can be error-prone. Instead, you can use this hook to ensure that
 * the callback is only run on the initial mount of the component.
 *
 * @param {function} callback - The callback function to run on mount.
 *
 * @returns {void}
 */
export const useDidMount = (callback) => {
  // Create a ref to track whether the callback has been executed
  const executed = useRef(false);

  // Run the callback on mount, but only if it has not been executed before
  useEffect(() => {
    if (!executed.current) {
      executed.current = true;
      callback()
    }
  }, [callback]);
};
